/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from '../shared/Globals';
import { qreq } from '../shared/qrequest';
import BaseCom from './BaseCom';
import FormInput from './FormInput';
import Icon from './Icon';
import L from './Lang';
import { withParamsAndNavigate } from './WithParamsAndNavigate';
import './Shop.css';
import Tick from './Tick';
import ProductModal from './ProductModal';
import AppActions from './AppActions';

class Shop extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            search: {},
            list: null,
            fullList: null,
            cart: null,
            loading: true
        };
    }

    async componentDidMount() {
        // MOUNT

        const products = await this.getProducts();
        const cart = await this.getCart();
        await this.loadCategory();

        if (products && cart)
            this.prepare(products, cart);

        this.setState({ loading: false });
    }

    getProducts = async () => {
        try {
            let qs = '';

            if (this.props.params.categoryID) {
                qs = '?categoryID=' + this.props.params.categoryID;
            }

            const j = await qreq.getAsync('/api/product/shop/list' + qs);

            if (j.list) {
                j.list.forEach(i => {
                    i.quantity = 0; //i.incrementBy;
                });

                this.setState({
                    list: j.list,
                    fullList: j.list
                });

                return j.list;
            }

            this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }

        return [];
    }

    loadCategory = async () => {
        if (this.props.params.categoryID) {
            try {
                const j = await qreq.getAsync('/api/category/get/' + this.props.params.categoryID);
                if (j.item) {
                    this.setState({ category: j.item });
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        }
    }

    addToCart = async (i) => {
        const info = { ...i };

        this.setState({ cartBusyId: i.id });

        try {
            let j = await qreq.postAsync('/api/cart/add', info);

            if (j.errorCode === 0) {
                i._added = true;
                Globals.set('cart', j.item);
                await this.getCart();
            }
            else {
                this.alert(j.errorMessage);
            }
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }

        this.setState({ cartBusyId: null });
    }

    removeFromCart = async (i) => {
        const info = { ...i };

        this.setState({ cartBusyId: i.id });

        try {
            let j = await qreq.postAsync('/api/cart/remove', info);

            if (j.errorCode === 0) {
                i.quantity = 0;
                i._added = false;
                Globals.set('cart', j.item);
                await this.getCart();
            }
            else {
                this.alert(j.errorMessage);
            }
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }

        this.setState({ cartBusyId: null });
    }

    updateCart = async (i) => {
        const info = { ...i };

        this.setState({ cartBusyId: i.id });

        try {
            let j = await qreq.postAsync('/api/cart/update', info);

            if (j.errorCode === 0) {
                Globals.set('cart', j.item);
                await this.getCart();
            }
            else {
                this.alert(j.errorMessage);
            }
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }

        this.setState({ cartBusyId: null });
    }

    prepare = (list, cart) => {
        if (!list || !cart)
            return;

        list.forEach(i => {
            let find = cart.products?.find(x => x.id === i.id);
            i._added = find ? true : false;

            if (find)
                i.quantity = find.quantity;
            else if (!i.quantity)
                i.quantity = 0;
        });

        this.setState({
            list: list,
            cart: cart
        });
    }

    tick = () => {
        const cart = Globals.get('cart');

        this.setState({ cart });

        if (!this.state.list || !cart)
            return;

        this.prepare(this.state.list, cart);
    }

    setQty = async (i, val) => {

        i.quantity = Number(val);

        if (i.quantity <= 0 && i._added) {
            this.removeFromCart(i);
            return;
        }

        if (i.quantity > i.incrementBy && i.quantity % i.incrementBy !== 0)
            i.quantity = i.quantity - (i.quantity % i.incrementBy);

        // if (i.quantity < i.incrementBy)
        //   i.quantity = i.incrementBy;
        if (i.quantity < 0)
            i.quantity = 0;

        if (i._added)
            await this.updateCart(i);

        this.forceUpdate();
    }

    search = (v) => {
        const value = (v || '').toLowerCase();

        this.setState({
            list: this.state.fullList?.filter(x =>
                (x.productName || '').toLowerCase().indexOf(value) >= 0
                || (x.catalogCode || '').toLowerCase().indexOf(value) >= 0
                || (x.description || '').toLowerCase().indexOf(value) >= 0
            )
        });
    }

    clearSearch = () => {
        this.state.search.query = '';

        this.setState({
            search: { ...this.state.search },
            list: this.state.fullList
        });
    }

    selectProduct = (p) => {
        this.setState({ currentProduct: p });
    }

    focus = (a) => {
        const list = [...this.state.list];
        list.forEach(i => {
            i.__focus = i === a;
        });
        this.setState({ list: list });
    }

    renderProduct = (i, idx) => {
        const isBusy = this.state.cartBusyId === i.id;

        return (
            <div key={idx} className="shop-product-card">
                <button type="button" className="shop-product-image" onClick={() => this.selectProduct(i)} title="View Product">
                    {i.imageIdent ? (
                        <img src={Globals.getStorageURL(i.imageIdent)} alt={i.productName || ''} />
                    ) : (
                        <div className="shop-product-placeholder">
                            <Icon icon="faBoxOpen" />
                        </div>
                    )}
                </button>

                <div className="shop-product-content">
                    <div className="shop-product-meta">
                        <span><L>Item No</L>: {i.catalogCode}</span>
                    </div>

                    <h2>{i.productName}</h2>

                    <p>{i.description}</p>

                    <button type="button" className="btn btn-link shop-details-link" onClick={() => this.selectProduct(i)}>
                        <L>View Details</L> <Icon icon="faArrowRight" />
                    </button>
                </div>

                <div className="shop-product-actions">
                    <label className="shop-qty-label"><L>Quantity</L></label>
                    <div className="input-group shop-qty-group">
                        <span className="input-group-text"><L>Qty</L></span>
                        <input
                            type="text"
                            step={i.incrementBy ?? 1}
                            min={0}
                            className="form-control"
                            value={i.quantity}
                            onChange={(e) => this.setQty(i, e.target.value)}
                            onFocus={() => this.focus(i)}
                        />
                        {i.__focus && <div className="d-flex gap-1 d-block w-100 mt-1">
                            <button type="button" className="btn btn-secondary btn-lg flex-fill" onClick={() => this.setQty(i, Number(i.quantity) - (i.incrementBy * 10))}><Icon icon="faBackward" /></button>
                            <button type="button" className="btn btn-secondary btn-lg flex-fill" onClick={() => this.setQty(i, Number(i.quantity) - i.incrementBy)}><Icon icon="faCaretLeft" /></button>
                            <button type="button" className="btn btn-secondary btn-lg flex-fill" onClick={() => this.setQty(i, Number(i.quantity) + i.incrementBy)}><Icon icon="faCaretRight" /></button>
                            <button type="button" className="btn btn-secondary btn-lg flex-fill" onClick={() => { if (Number(i.quantity) === 1) this.setQty(i, Number(i.quantity) + ((i.incrementBy * 10) - 1)); else this.setQty(i, Number(i.quantity) + (i.incrementBy * 10)); }}><Icon icon="faForward" /></button>
                        </div>}
                    </div>

                    {!i._added && <div className="text-center">
                        <small className="text-muted"><L>Please select a quantity.</L></small>
                    </div>}

                    {i._added ? (
                        <>
                            <button type="button" className="btn btn-success shop-action-btn" onClick={this.cartCheckout} title="Go to Checkout" disabled={isBusy}>
                                <Icon icon="faCartShopping" /> <L>Continue</L>
                            </button>

                            <button type="button" className="btn btn-outline-danger shop-action-btn" onClick={() => this.removeFromCart(i)} title="Remove from Cart" disabled={isBusy}>
                                {isBusy ? <Icon icon="faRefresh" className="spinner" /> : <Icon icon="faCancel" />} <L>Remove</L>
                            </button>
                        </>
                    ) : (
                        <button type="button" className="btn btn-primary shop-action-btn" onClick={() => this.addToCart(i)} title="Add to Order" disabled={isBusy || !i.quantity}>
                            {isBusy ? <Icon icon="faRefresh" className="spinner" /> : <Icon icon="faCartArrowDown" />} <L>Add to Order</L>
                        </button>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const count = this.state.list?.length ?? 0;

        return (
            <div className="shop-page">
                <Tick interval={1000} onTick={this.tick} />

                {this.props.params.categoryID && <AppActions />}

                <div className="shop-hero">
                    <div>
                        <span className="shop-eyebrow"><L>Catalog</L></span>
                        {this.state.category && <h1>{this.state.category.name}</h1>}
                        {!this.state.category && <h1><L>Products</L></h1>}
                        <p><L>Browse products, adjust quantities, and add items to your cart.</L></p>
                    </div>

                    <div role="button" className="shop-cart-pill" onClick={this.cartCheckout}>
                        <Icon icon="faCartShopping" />
                        <span>{this.state.cart?.totalQuantity ?? 0}</span>
                    </div>
                </div>

                <div className="shop-toolbar">
                    <div className="shop-search">
                        <Icon icon="faSearch" />
                        <FormInput model={this.state.search} name="query" label="Search products, item numbers, or descriptions..." labelAsPlaceholder onChange={this.search} />
                    </div>

                    {this.state.search?.query ? (
                        <button type="button" className="btn btn-light" onClick={this.clearSearch}>
                            <Icon icon="faCancel" /> <L>Clear</L>
                        </button>
                    ) : null}
                </div>


                {this.state.loading ? (
                    <div className="shop-loading">
                        <Icon icon="faRefresh" className="spinner" />
                        <span><L>Loading products...</L></span>
                    </div>
                ) : count === 0 ? (
                    <div className="shop-empty">
                        <Icon icon="faBoxOpen" />
                        <h2><L>No Products Found</L></h2>
                        <p><L>Try changing your search keywords.</L></p>
                    </div>
                ) : (
                    <div className="shop-product-list">
                        {this.state.list?.map((i, idx) => this.renderProduct(i, idx))}
                    </div>
                )}

                <ProductModal currentProduct={this.state.currentProduct} onHide={() => this.setState({ currentProduct: null })} />
            </div>
        );
    }
}

export default withParamsAndNavigate(Shop);
